import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type JiraApplicationKey,
	type JiraProjectType,
} from './__generated__/dialogStandardTrialLimitBreakersQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	projectType: JiraProjectType;
	jiraApplicationKey: JiraApplicationKey;
	shouldIncludeIfProductIsConfluence: boolean;
	shouldIncludeIfProductIsJiraSoftware: boolean;
};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-trial-limit-breakers-dialog" */ './dialog'
			),
		{
			moduleId: 'edition-awareness-standard-trial-limit-breakers-dialog',
		},
	),
	getPreloadProps: ({
		cloudId,
		jiraApplicationKey,
		projectType,
		shouldIncludeIfProductIsConfluence,
		shouldIncludeIfProductIsJiraSoftware,
	}: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			tenantContexts: {
				parameters,
				variables: {
					cloudId,
					jiraApplicationKey,
					projectType,
					shouldIncludeIfProductIsConfluence,
					shouldIncludeIfProductIsJiraSoftware,
				},
			},
		},
	}),
});
